/**
* Nom : equipmentNew.js
* Description : Ce fichier contient la définition de la page equipmentNew 
*               Cette page fourni un formulaire pour créer un produit client
*               Le terme 'equipment' dans le code correspond à un produit client
* Date de création : 10 mars 2025
*/

/* CSS et assets */
// None

/* Bibliothèques et composants */
import { CompanyBar } from 'package_ui_ihm/dist'
import { TabC } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { BackPage } from 'package_ui_ihm/dist'
import { GotoPage } from 'package_ui_ihm/dist'
import { SelectForm} from 'package_ui_ihm/dist'
import { InputForm } from 'package_ui_ihm/dist'

/* Hook */
import { useState, useEffect } from 'react'
import { useBlocker } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useNavigate } from 'react-router-dom'
import { useScreenWidth } from 'package_ui_ihm/dist'


/**
* EquipmentNew : affiche une page avec un formulaire pour créer un produit client
*                un lien permet de revenir sur la page qui liste tous les produits client 
*
* Type : page 
*
* Parametres : 
*  None
*/
function EquipmentNew() {

    // Define useState hooks
    const [serialNumber, setSerialNumber] = useState('');
    const [version, setVersion] = useState('');
    const [identifier, setIdentifier] = useState('');
    const [selectedCompany, setSelectedCompany] = useState(0)
    const [selectedProduct, setSelectedProduct] = useState(0)
    const [selectedStatus, setSelectedStatus] = useState(1);
    const [statusEquipment, setStatusEquipment] = useState(null)
    const [equipment, setEquipment] = useState(null)
    const [statusLedSetting, setStatusLedSetting] = useState(null)
    const [statusCpuBox, setStatusCpuBox] = useState(null)
    const [statusPowerBox, setStatusPowerBox] = useState(null)
    const [statusTunnelBox, setStatusTunnelBox] = useState(null)
    const [statusRoverBox, setStatusRoverBox] = useState(null)
    const [statusLabBox, setStatusLabBox] = useState(null)
    const [statusStickBox, setStatusStickBox] = useState(null)
    const [statusPtu, setStatusPtu] = useState(null)
    const [companies, setCompanies] = useState([])
    const [products, setProducts] = useState([])
    const [status, setStatus] = useState([])
    const [serialNumberError, setSerialNumberError] = useState(false);
    const [versionError, setVersionError] = useState(false);
    const [identifierError, setIdentifierError] = useState(false);
    const [companyError, setCompanyError] = useState(false);
    const [productError, setProductError] = useState(false);
    const [statusError, setStatusError] = useState(false);
    const [selectedCpuBox, setSelectedCpuBox] = useState(0)
    const [selectedPowerBox, setSelectedPowerBox] = useState(0)
    const [selectedTunnelBox, setSelectedTunnelBox] = useState(0)
    const [selectedRoverBox, setSelectedRoverBox] = useState(0)
    const [selectedLabBox, setSelectedLabBox] = useState(0)
    const [selectedStickBox, setSelectedStickBox] = useState(0)
    const [selectedPtu1, setSelectedPtu1] = useState(0)
    const [selectedPtu2, setSelectedPtu2] = useState(0)
    const [selectedPtu3, setSelectedPtu3] = useState(0)
    const [selectedPtu4, setSelectedPtu4] = useState(0)
    const [cpuBoxes, setCpuBoxes] = useState([])
    const [powerBoxes, setPowerBoxes] = useState([])
    const [tunnelBoxes, setTunnelBoxes] = useState([])
    const [roverBoxes, setRoverBoxes] = useState([])
    const [labBoxes, setLabBoxes] = useState([])
    const [stickBoxes, setStickBoxes] = useState([])
    const [ptus, setPtus] = useState([])
    const [cpuBoxError, setCpuBoxError] = useState(false)
    const [powerBoxError, setPowerBoxError] = useState(false)
    const [tunnelBoxError, setTunnelBoxError] = useState(false)
    const [roverBoxError, setRoverBoxError] = useState(false)
    const [labBoxError, setLabBoxError] = useState(false)
    const [stickBoxError, setStickBoxError] = useState(false)
    const [ptu1Error, setPtu1Error] = useState(false)
    const [ptu2Error, setPtu2Error] = useState(false)
    const [ptu3Error, setPtu3Error] = useState(false)
    const [ptu4Error, setPtu4Error] = useState(false)
    const [productName, setProductName] = useState(null)
    const [formSubmit, setFormSubmit] = useState(false);
    const [skipPrompt, setSkipPrompt] = useState(false);



    // Define useContext hooks
    const { authStatus, authToken } = useAuth();
    const { path, setPreviousUrl } = useApi();

    const navigate = useNavigate();


    // Define useBlocker hooks
    const shouldBlock = 
        ((serialNumber !== "") || 
        (version !== "") || 
        (identifier !== "") || 
        (selectedCompany !== "0" && selectedCompany !== 0) ||
        (selectedProduct !== "0" && selectedProduct !== 0) ||
        (selectedStatus !== "1" && selectedStatus !== 1) ||
        (selectedCpuBox !== "0" && selectedCpuBox !== 0) ||
        (selectedPowerBox !== "0" && selectedPowerBox !== 0) ||
        (selectedTunnelBox !== "0" && selectedTunnelBox !== 0) ||
        (selectedRoverBox !== "0" && selectedRoverBox !== 0) ||
        (selectedLabBox !== "0" && selectedLabBox !== 0) ||
        (selectedStickBox !== "0" && selectedStickBox !== 0) ||
        (selectedPtu1 !== "0" && selectedPtu1 !== 0) ||
        (selectedPtu2 !== "0" && selectedPtu2 !== 0) ||
        (selectedPtu3 !== "0" && selectedPtu3 !== 0) ||
        (selectedPtu4 !== "0" && selectedPtu4 !== 0)) &&
        (skipPrompt === false);
    const blocker = useBlocker(shouldBlock);


    // Define useScreenWidth hooks
    const screenWidth = useScreenWidth();


    // Define functions
    async function sendData(serial_number, version, identifier, company_id, product_id, status_id) {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("identifier", identifier);
        form_data.append("company_id", Number(company_id));
        form_data.append("product_id", Number(product_id));
        form_data.append("status_id", Number(status_id));
        form_data.append("date_last_synchro", "Aucune synchronisation");
        form_data.append("serial_number", serial_number);
        form_data.append("version", version);
        // Create Equipment
        const response = await fetch(path + "/api/eq-eqnt/", 
            {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        )
        setStatusEquipment(response["status"])
        const data = await response.json();
        setEquipment(data)
    }

    async function createLedSetting() {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("equipment_id", equipment['id']);
        form_data.append("status", 0);
        form_data.append("start_hour", '00');
        form_data.append("start_minute", '00');
        form_data.append("stop_hour", '00');
        form_data.append("stop_minute", '00');
        form_data.append("day_1", 0);
        form_data.append("day_2", 0);
        form_data.append("day_3", 0);
        form_data.append("day_4", 0);
        form_data.append("day_5", 0);
        form_data.append("day_6", 0);
        form_data.append("day_7", 0);
        form_data.append("period2_enable", 0);
        form_data.append("start_hour_period2", '00');
        form_data.append("start_minute_period2", '00');
        form_data.append("stop_hour_period2", '00');
        form_data.append("stop_minute_period2", '00');
        form_data.append("hour_timer", '00');
        form_data.append("minute_timer", '00');
        form_data.append("second_timer", '00');
        form_data.append("repeat_timer_enable", 0);
        form_data.append("datetime", "Aucune synchronisation");
        // Create LedSetting
        const response = await fetch(path + "/api/eq-lese/", 
            {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        )
        setStatusLedSetting(response["status"])
    }

    async function updateCpuBox() {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("equipment_id", equipment['id']);
        // Update cpu_box
        const response = await fetch(path + "/api/eq-cpbo/" + selectedCpuBox + "/", 
            {
                method: 'PATCH',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        )
        setStatusCpuBox(response["status"])
    }

    async function updatePowerBox() {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("equipment_id", equipment['id']);
        // Update power_box
        const response = await fetch(path + "/api/eq-pobo/" + selectedPowerBox + "/", 
            {
                method: 'PATCH',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        )
        setStatusPowerBox(response["status"])
    }

    async function updateTunnelBox() {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("equipment_id", equipment['id']);
        // Update tunnel_box
        const response = await fetch(path + "/api/eq-tubo/" + selectedTunnelBox + "/", 
            {
                method: 'PATCH',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        )
        setStatusTunnelBox(response["status"])
    }

    async function updateRoverBox() {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("equipment_id", equipment['id']);
        // Update rover_box
        const response = await fetch(path + "/api/eq-robo/" + selectedRoverBox + "/", 
            {
                method: 'PATCH',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        )
        setStatusRoverBox(response["status"])
    }

    async function updateLabBox() {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("equipment_id", equipment['id']);
        // Update lab_box
        const response = await fetch(path + "/api/eq-labo/" + selectedLabBox + "/", 
            {
                method: 'PATCH',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        )
        setStatusLabBox(response["status"])
    }

    async function updateStickBox() {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("equipment_id", equipment['id']);
        // Update stick_box
        const response = await fetch(path + "/api/eq-stbo/" + selectedStickBox + "/", 
            {
                method: 'PATCH',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        )
        setStatusStickBox(response["status"])
    }

    async function updatePtus() {
        let status = 200;
        // Token
        const token = "Bearer " + authToken
        // Headers
        const headers = {
            accept: 'application/json',
            //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
            Authorization: token,
        }
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("equipment_id", equipment['id']);
        // Update ptus
        if(selectedPtu1 !== 0){
            form_data.append("port", 1);
            const responsePtu1 = await fetch(path + "/api/eq-mole/" + selectedPtu1 + "/", 
                {
                    method: 'PATCH',
                    credentials: 'include',
                    mode: 'cors',
                    headers,
                    body: form_data
                }
            )
            status = responsePtu1["status"];
        }
        if(selectedPtu2 !== 0){
            form_data.append("port", 2);
            const responsePtu2 = await fetch(path + "/api/eq-mole/" + selectedPtu2 + "/", 
                {
                    method: 'PATCH',
                    credentials: 'include',
                    mode: 'cors',
                    headers,
                    body: form_data
                }
            )
            if(status === 200){
                status = responsePtu2["status"];
            }
        }
        if(selectedPtu3 !== 0){
            form_data.append("port", 3);
            const responsePtu3 = await fetch(path + "/api/eq-mole/" + selectedPtu3 + "/", 
                {
                    method: 'PATCH',
                    credentials: 'include',
                    mode: 'cors',
                    headers,
                    body: form_data
                }
            )
            if(status === 200){
                status = responsePtu3["status"];
            }
        }
        if(selectedPtu4 !== 0 ){
            form_data.append("port", 4);
            const responsePtu4 = await fetch(path + "/api/eq-mole/" + selectedPtu4 + "/", 
                {
                    method: 'PATCH',
                    credentials: 'include',
                    mode: 'cors',
                    headers,
                    body: form_data
                }
            )
            if(status === 200){
                status = responsePtu4["status"];
            }
        }
        setStatusPtu(status);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setSkipPrompt(true);
        // Check of data for equipment
        if(serialNumber === null || serialNumber === ''){
            setSerialNumberError(true)
        }
        else
        {   
            setSerialNumberError(false)
        }
        if(version === null || version === ''){
            setVersionError(true)
        }
        else
        {   
            setVersionError(false)
        }
        if(identifier === null || identifier === ''){
            setIdentifierError(true)
        }
        else
        {   
            setIdentifierError(false)
        }
        if(selectedCompany === 0 || selectedCompany === '0'){
            setCompanyError(true)
        }
        else
        {   
            setCompanyError(false)
        }
        if(selectedProduct === 0 || selectedProduct === '0'){
            setProductError(true)
        }
        else
        {   
            setProductError(false)
        }
        if(selectedStatus === 0 || selectedStatus === '0'){
            setStatusError(true)
        }
        else
        {   
            setStatusError(false)
        } 
        if(productName === 'Boxitunnel' && Number(selectedCpuBox) === 0 && (version.startsWith('1') || version.startsWith('2')) && (!version.startsWith('2.1'))){
            setCpuBoxError(true)
        }
        else
        {   
            setCpuBoxError(false)
        } 
        if(productName === 'Boxitunnel' && Number(selectedPowerBox) === 0 && (version.startsWith('1') || version.startsWith('2')) && (!version.startsWith('2.1'))){
            setPowerBoxError(true)
        }
        else
        {   
            setPowerBoxError(false)
        } 
        if(productName === 'Boxitunnel' && Number(selectedTunnelBox) === 0 && (version.startsWith('2.1'))){
            setTunnelBoxError(true)
        }
        else
        {   
            setTunnelBoxError(false)
        } 
        if(productName === 'Boxirover' && Number(selectedRoverBox) === 0 ){
            setRoverBoxError(true)
        }
        else
        {   
            setRoverBoxError(false)
        } 
        if(productName === 'BoxiLab' && Number(selectedLabBox) === 0 ){
            setLabBoxError(true)
        }
        else
        {   
            setLabBoxError(false)
        } 
        if(productName === 'Boxistick' && Number(selectedStickBox) === 0 ){
            setStickBoxError(true)
        }
        else
        {   
            setStickBoxError(false)
        }
        if(selectedPtu1 === 0 || selectedPtu1 === '0'){
            setPtu1Error(true)
        }
        else
        {   
            setPtu1Error(false)
        }
        if((productName === 'Boxitunnel' || productName === 'Boxirover' || productName === 'BoxiLab' || productName === 'Boxiclean') && (Number(selectedPtu2) > 0) && (Number(selectedPtu2) === Number(selectedPtu1)) ){
            setPtu2Error(true)
        }
        else
        {   
            setPtu2Error(false)
        } 
        if((productName === 'Boxitunnel' || productName === 'Boxirover' || productName === 'BoxiLab') && (Number(selectedPtu3) > 0) && (Number(selectedPtu3) === Number(selectedPtu1) || Number(selectedPtu3) === Number(selectedPtu2)) ){
            setPtu3Error(true)
        }
        else
        {   
            setPtu3Error(false)
        } 
        if((productName === 'Boxitunnel' || productName === 'Boxirover') && (Number(selectedPtu4) > 0) && (Number(selectedPtu4) === Number(selectedPtu1) || Number(selectedPtu4) === Number(selectedPtu2) || Number(selectedPtu4) === Number(selectedPtu3)) ){
            setPtu4Error(true)
        }
        else
        {   
            setPtu4Error(false)
        } 
        setFormSubmit(true)
    };

    async function retrieveData() {
        // Token
        const token = "Bearer " + authToken
        // Headers
        const headers = {
            accept: 'application/json',
            Authorization: token,
        }
        // Requests in parallel to win time 
        const [resCompany, resProduct, resStatus] = await Promise.all([
            // Companies
            fetch(path + "/api/au-cony/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Products
            fetch(path + "/api/eq-prct/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Status
            fetch(path + "/api/eq-stus", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
        ])
        // Responses in parallel to win time
        const [dataCompany, dataProduct, dataStatus] = await Promise.all([
            resCompany.json(),
            resProduct.json(),
            resStatus.json(),
        ])
        // Set variables
        setCompanies(dataCompany["results"])
        setProducts(dataProduct["results"])
        setStatus(dataStatus["results"])
    }

    async function retrieveBoxitunnelDataV1V2_0() {
        // Set product
        setProductName('Boxitunnel')
        // Token
        const token = "Bearer " + authToken
        // Headers
        const headers = {
            accept: 'application/json',
            Authorization: token,
        }
        // Requests in parallel to win time 
        const [resCpuBox, resPowerBox, resPtu] = await Promise.all([
            // CpuBoxes
            fetch(path + "/api/eq-cpbo/?equipment_id=0", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // PowerBoxes
            fetch(path + "/api/eq-pobo/?equipment_id=0", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Ptus
            fetch(path + "/api/eq-mole/?equipment_id=0&product_id=" + selectedProduct, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
        ])
        // Responses in parallel to win time
        const [dataCpuBox, dataPowerBox, dataPtu] = await Promise.all([
            resCpuBox.json(),
            resPowerBox.json(),
            resPtu.json(),
        ])
        // Set variables
        setCpuBoxes(dataCpuBox["results"])
        setPowerBoxes(dataPowerBox["results"])
        setPtus(dataPtu["results"])
    }

    async function retrieveBoxitunnelDataV2_1sup() {
        // Set product
        setProductName('Boxitunnel')
        // Token
        const token = "Bearer " + authToken
        // Headers
        const headers = {
            accept: 'application/json',
            Authorization: token,
        }
        // Requests in parallel to win time 
        const [resTunnelBox, resPtu] = await Promise.all([
            // TunnelBoxes
            fetch(path + "/api/eq-tubo/?equipment_id=0", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Ptus
            fetch(path + "/api/eq-mole/?equipment_id=0&product_id=" + selectedProduct, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
        ])
        // Responses in parallel to win time
        const [dataTunnelBox, dataPtu] = await Promise.all([
            resTunnelBox.json(),
            resPtu.json(),
        ])
        // Set variables
        setTunnelBoxes(dataTunnelBox["results"])
        setPtus(dataPtu["results"])
    }

    async function retrieveBoxiroverData() {
        // Set product
        setProductName('Boxirover')
        // Token
        const token = "Bearer " + authToken
        // Headers
        const headers = {
            accept: 'application/json',
            Authorization: token,
        }
        // Requests in parallel to win time 
        const [resRoverBox, resPtu] = await Promise.all([
            // RoverBoxes
            fetch(path + "/api/eq-robo/?equipment_id=0", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Ptus
            fetch(path + "/api/eq-mole/?equipment_id=0&product_id=" + selectedProduct, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
        ])
        // Responses in parallel to win time
        const [dataRoverBox, dataPtu] = await Promise.all([
            resRoverBox.json(),
            resPtu.json(),
        ])
        // Set variables
        setRoverBoxes(dataRoverBox["results"])
        setPtus(dataPtu["results"])
    }

    async function retrieveBoxilabData() {
        // Set product
        setProductName('BoxiLab')
        // Token
        const token = "Bearer " + authToken
        // Headers
        const headers = {
            accept: 'application/json',
            Authorization: token,
        }
        // Requests in parallel to win time 
        const [resLabBox, resPtu] = await Promise.all([
            // LabBoxes
            fetch(path + "/api/eq-labo/?equipment_id=0", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Ptus
            fetch(path + "/api/eq-mole/?equipment_id=0&product_id=" + selectedProduct, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
        ])
        // Responses in parallel to win time
        const [dataLabBox, dataPtu] = await Promise.all([
            resLabBox.json(),
            resPtu.json(),
        ])
        // Set variables
        setLabBoxes(dataLabBox["results"])
        setPtus(dataPtu["results"])
    }

    async function retrieveBoxistickData() {
        // Set product
        setProductName('Boxistick')
        // Token
        const token = "Bearer " + authToken
        // Headers
        const headers = {
            accept: 'application/json',
            Authorization: token,
        }
        // Requests in parallel to win time 
        const [resStickBox, resPtu] = await Promise.all([
            // StickBoxes
            fetch(path + "/api/eq-stbo/?equipment_id=0", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Ptus
            fetch(path + "/api/eq-mole/?equipment_id=0&product_id=" + selectedProduct, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
        ])
        // Responses in parallel to win time
        const [dataStickBox, dataPtu] = await Promise.all([
            resStickBox.json(),
            resPtu.json(),
        ])
        // Set variables
        setStickBoxes(dataStickBox["results"])
        setPtus(dataPtu["results"])
    }
    
    async function retrieveBoxicleanData() {
        // Set product
        setProductName('Boxiclean')
        // Token
        const token = "Bearer " + authToken
        // Retrieve ptu list
        const resPtu = await fetch(path + "/api/eq-mole/?equipment_id=0&product_id=" + selectedProduct, 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataPtu = await resPtu.json();
        setPtus(dataPtu["results"])
    }

    function updateDisplayToproduct() {
        if(Number(selectedProduct) === 1){
            if((version.startsWith('1') || version.startsWith('2')) && (!version.startsWith('2.1')))
            {
                retrieveBoxitunnelDataV1V2_0()
            }
            else 
            {
                retrieveBoxitunnelDataV2_1sup()
            }
        }
        else if(Number(selectedProduct) === 2){
            retrieveBoxilabData()
        }
        else if(Number(selectedProduct) === 3){
            retrieveBoxistickData()
        }
        else if(Number(selectedProduct) === 4){
            retrieveBoxiroverData()
        }
        else if(Number(selectedProduct) === 5){
            retrieveBoxicleanData()
        }
        else {
            setProductName(null)
        }
    }


    // Define useEffect hooks
    useEffect(() => {
        if(authStatus === 200)
        {
            retrieveData()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(statusEquipment === 201 && equipment !== null) {
            if(productName === 'Boxitunnel' || productName === 'Boxirover')
            {
                createLedSetting()
            }
            else if(productName === 'BoxiLab')
            {
                updateLabBox()
            }
            else if(productName === 'Boxistick')
            {
                updateStickBox()
            }
            else if(productName === 'Boxiclean')
            {
                updatePtus()
            }
        } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusEquipment, equipment]);

    useEffect(() => {
        if(statusLedSetting === 201) {
            if(productName === 'Boxitunnel')
            {
                if((version.startsWith('1') || version.startsWith('2')) && (!version.startsWith('2.1')))
                {
                    updateCpuBox()
                }
                else 
                {
                    updateTunnelBox()
                }
            }
            else if(productName === 'Boxirover')
            {
                updateRoverBox()
            }
        } else {
            setFormSubmit(false)
            navigate('/equipments/new')
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusLedSetting]);

    useEffect(() => {
        if(statusCpuBox === 200) {
            updatePowerBox()
        } else {
            setFormSubmit(false)
            navigate('/equipments/new')
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusCpuBox]);

    useEffect(() => {
        if(statusPowerBox === 200 || statusTunnelBox === 200 || statusRoverBox === 200 || statusStickBox === 200 || statusLabBox === 200) {
            updatePtus()
        } else {
            setFormSubmit(false)
            navigate('/equipments/new')
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusPowerBox, statusTunnelBox, statusRoverBox, statusStickBox, statusLabBox]);

    useEffect(() => {
        if(statusPtu === 200) {
            setFormSubmit(false)
            const equipment_path = '/equipments/' + equipment["id"]
            navigate(equipment_path)
        } else {
            setFormSubmit(false)
            navigate('/equipments/new')
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusPtu]);

    useEffect(() => {
        updateDisplayToproduct()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedProduct, version]);

    useEffect(() => {
        if(formSubmit === true 
            && serialNumberError === false 
            && versionError === false 
            && identifierError === false 
            && companyError === false 
            && productError === false  
            && statusError === false 
            && cpuBoxError === false 
            && powerBoxError === false 
            && tunnelBoxError === false 
            && roverBoxError === false 
            && labBoxError === false
            && stickBoxError === false
            && ptu1Error === false 
            && ptu2Error === false 
            && ptu3Error === false 
            && ptu4Error === false)
        {
            sendData(serialNumber, version, identifier, selectedCompany, selectedProduct, selectedStatus)
        } else {
            setSkipPrompt(false);
            setFormSubmit(false)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formSubmit]) 

    useEffect(() => {
        // Bloquer la fermeture d'onglet/rafraîchissement
        const handleBeforeUnload = (e) => {
            if (shouldBlock === true) {
                // Standard pour afficher une confirmation (les navigateurs modernes gèrent le message)
                e.preventDefault();
                e.returnValue = "";
                // Certains navigateurs nécessitent cette ligne pour afficher la confirmation
                return (e.returnValue = "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées.");
            }
        }; 

        window.addEventListener("beforeunload", handleBeforeUnload);

        // Nettoyer l'écouteur quand le composant est démonté
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldBlock]);

    useEffect(() => {
        if (blocker.state === "blocked") {
            const confirmed = window.confirm(
                "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées."
            );

            if (confirmed) {
                blocker.proceed();
            } else {
                blocker.reset();
            }
        }
    }, [blocker]);


    // Render component
    return (
        <div>
            <CompanyBar name_app="BOXIBRAIN"/>
            <TabC tabNumber={1}/>
            <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
                <Container>
                    <h1>Créer un nouveau produit client</h1>
                    {/*Lien de retour*/}
                    <div className={(screenWidth > 650) ? 'flex-row justify-center margin-bottom margin-top' : 'grid-1-1 justify-center margin-bottom margin-top'}>
                        <div className='link-border'>
                            <BackPage path='/equipments'>Retour à la liste des produits client</BackPage>
                        </div>
                        <div className='link-border'>
                            <GotoPage onClick={setPreviousUrl('/equipments/new')} path={'/equipments/subset'}>Gérer les sous-ensembles</GotoPage>
                        </div>
                    </div>
                    {(statusEquipment !== null && statusEquipment !== 201 && serialNumberError === false && versionError === false && identifierError === false && companyError === false && productError === false && statusError === false && cpuBoxError === false && powerBoxError === false && tunnelBoxError === false && roverBoxError === false && labBoxError === false && stickBoxError === false) ? (
                        <p className='form-error'>Le produit client existe déjà ou n'a pas pu être enregistré !</p>
                    ) : (
                        <p/>
                    )}  
                    <form onSubmit={handleSubmit} className='flex-column'>
                        <div className='flex-column form-center'>
                            <SelectForm error={companyError} labelText='Société' choices={companies.sort((a, b) => (a.name > b.name)?1:-1)} selectedItem={selectedCompany} setSelectedItem={setSelectedCompany}/>
                            <SelectForm error={productError} labelText='Produit' choices={products.sort((a, b) => (a.name > b.name)?1:-1)} selectedItem={selectedProduct} setSelectedItem={setSelectedProduct}/>   
                            <InputForm error={versionError} type="text" label="Version" value={version} setValue={setVersion} disabled={false}/>
                            <InputForm error={serialNumberError} type="text" label="Serial number" value={serialNumber} setValue={setSerialNumber} disabled={false}/>
                            <div className='italic-text-note-50 margin-bottom'>
                                <p className='zero-margin-top zero-margin-bottom'>Serial number = SN- + premiere lettre du produit en majuscule + '-' + numéro de version du produit + 4 chiffres. Exemple: SN-T-1-0001</p>
                            </div>
                            <InputForm error={identifierError} type="text" label="Identifiant" value={identifier} setValue={setIdentifier} disabled={false}/>
                            <SelectForm error={statusError} labelText='Status' choices={status} selectedItem={selectedStatus} setSelectedItem={setSelectedStatus}/>
                        </div>
                        {(productName === 'Boxitunnel') ? (
                            <div className='flex-column form-center'>
                                {((version.startsWith('1') || version.startsWith('2')) && (!version.startsWith('2.1'))) ? (
                                    <SelectForm error={cpuBoxError} labelText='Boitier CPU' choices={cpuBoxes.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedCpuBox} setSelectedItem={setSelectedCpuBox}/>
                                ) : (
                                    null                                
                                )}
                                {((version.startsWith('1') || version.startsWith('2')) && (!version.startsWith('2.1'))) ? (
                                    <SelectForm error={powerBoxError} labelText='Boitier de distribution' choices={powerBoxes.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedPowerBox} setSelectedItem={setSelectedPowerBox}/>    
                                ) : (
                                    <SelectForm error={tunnelBoxError} labelText='Boitier Boxitunnel' choices={tunnelBoxes.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedTunnelBox} setSelectedItem={setSelectedTunnelBox}/>    
                                )}
                                <SelectForm error={ptu1Error} labelText='PTU 1' choices={ptus.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedPtu1} setSelectedItem={setSelectedPtu1}/>
                                <SelectForm error={ptu2Error} labelText='PTU 2' choices={ptus.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedPtu2} setSelectedItem={setSelectedPtu2}/>
                                <SelectForm error={ptu3Error} labelText='PTU 3' choices={ptus.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedPtu3} setSelectedItem={setSelectedPtu3}/>
                                <SelectForm error={ptu4Error} labelText='PTU 4' choices={ptus.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedPtu4} setSelectedItem={setSelectedPtu4}/>                        
                            </div>
                        ) : (
                            (productName === 'BoxiLab') ? (
                                <div className='flex-column form-center'>
                                    <SelectForm error={labBoxError} labelText='Boitier Boxilab' choices={labBoxes.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedLabBox} setSelectedItem={setSelectedLabBox}/>
                                    <SelectForm error={ptu1Error} labelText='PTU 1' choices={ptus.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedPtu1} setSelectedItem={setSelectedPtu1}/>
                                    <SelectForm error={ptu2Error} labelText='PTU 2' choices={ptus.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedPtu2} setSelectedItem={setSelectedPtu2}/>
                                    <SelectForm error={ptu3Error} labelText='PTU 3' choices={ptus.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedPtu3} setSelectedItem={setSelectedPtu3}/>
                                </div>
                            ) : (
                                (productName === 'Boxistick') ? (
                                    <div className='flex-column form-center'>
                                        <SelectForm error={stickBoxError} labelText='Boitier Boxistick' choices={stickBoxes.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedStickBox} setSelectedItem={setSelectedStickBox}/>
                                        <SelectForm error={ptu1Error} labelText='PTU' choices={ptus.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedPtu1} setSelectedItem={setSelectedPtu1}/>
                                    </div>
                                ) : (
                                    (productName === 'Boxiclean') ? (
                                        <div className='flex-column form-center'>
                                            <SelectForm error={ptu1Error} labelText='PTU 1' choices={ptus.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedPtu1} setSelectedItem={setSelectedPtu1}/>
                                            <SelectForm error={ptu2Error} labelText='PTU 2' choices={ptus.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedPtu2} setSelectedItem={setSelectedPtu2}/>
                                        </div>
                                    ) : (
                                        (productName === 'Boxirover') ? (
                                            <div className='flex-column form-center'>
                                                <SelectForm error={roverBoxError} labelText='Boitier Boxirover' choices={roverBoxes.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedRoverBox} setSelectedItem={setSelectedRoverBox}/>    
                                                <SelectForm error={ptu1Error} labelText='PTU 1' choices={ptus.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedPtu1} setSelectedItem={setSelectedPtu1}/>
                                                <SelectForm error={ptu2Error} labelText='PTU 2' choices={ptus.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedPtu2} setSelectedItem={setSelectedPtu2}/>
                                                <SelectForm error={ptu3Error} labelText='PTU 3' choices={ptus.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedPtu3} setSelectedItem={setSelectedPtu3}/>
                                                <SelectForm error={ptu4Error} labelText='PTU 4' choices={ptus.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)} selectedItem={selectedPtu4} setSelectedItem={setSelectedPtu4}/>                        
                                            </div>
                                        ) : (
                                            null
                                        )
                                    )
                                )
                            )
                        )}
                        <div className='flex-column form-right'>
                            <button type="submit" className='button'>Valider</button>
                        </div>
                    </form> 
                </Container>
            </div>
        </div>
    );
}

export default EquipmentNew;
